import { Component } from '@angular/core';
import { FortuneDetailWidgetComponent } from '../widgets/fortune/fortune-detail-widget.component';

@Component({
  selector: 'app-listing-page',
  imports: [FortuneDetailWidgetComponent],
  template: `<app-fortune-detail-widget />`
})
export class ListingPage {}
